export const criticalData = {
  acceptable: {
    description: "acceptable_desc",
    color: "acceptable",
    label: "Acceptable",
    title: "Acceptable",
    colorCode: "#458DE1",
  },
  moderate: {
    description: "moderate_desc",
    color: "moderate",
    label: "moderate",
    title: "moderate",
    colorCode: "#C9B300",
  },
  high: {
    description: "high_desc",
    color: "high",
    label: "high",
    title: "high",
    // colorCode: "#FF857F",
    colorCode: "#FFB267",
  },
  very_high: {
    description: "very_high_desc",
    color: "very_high",
    label: "very_high",
    title: "very_high",
    colorCode: "#FF0000",
  },
  critical: {
    description: "critical_desc",
    color: "critical",
    label: "critical",
    title: "critical",
    colorCode: "#630101",
  },

  disbaled: {
    description: "disbaled_desc",
    color: "disbaled",
    label: "disbaled",
    title: "disbaled",
    colorCode: "grey",
  },
};
